import React from "react"
import { Link } from "react-router-dom"

export default class MyLink extends React.PureComponent {
  render() {
    if (this.props.to) {
      return  <Link to={this.props.to} style={this.props.style}>
        {this.props.children}
      </Link>
    }
    else return <div>
      {this.props.children}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/components/Link.jsx